import { render } from "./DataAccess.vue?vue&type=template&id=169cac6c"
import script from "./DataAccess.vue?vue&type=script&lang=js"
export * from "./DataAccess.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__